import React from 'react';
import PropTypes from 'prop-types';

const ChevronRightIcon = ({ className, color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='6'
    height='9'
    viewBox='0 0 6 9'
    className={className}
  >
    <path
      fill='#FFF'
      fillRule='nonzero'
      stroke='#FFF'
      strokeWidth='.3'
      d='M5.387 4.5l-.386-.406-3.333-3.5-1.055.812L3.56 4.5.613 7.594l1.055.812L5 4.906z'
    />
  </svg>
);

ChevronRightIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default ChevronRightIcon;



// WEBPACK FOOTER //
// ./src/icons/ChevronRightIcon.js